import React from 'react';
import DateTimeDisplay from './DateTimeDisplay';
import Countdown from "./CountDown";

const ExpiredNotice = () => {
    return (
        <div className="expired-notice">
            <span>Expired!!!</span>
        </div>
    );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
    return (
        <>
            <DateTimeDisplay value={days} type={'Days'} />
            <DateTimeDisplay value={hours} type={'Hours'} />
            <DateTimeDisplay value={minutes} type={'Mins'} />
            <DateTimeDisplay value={seconds} type={'Seconds'} />
        </>
    );
};

const CountdownTimer = ({ targetDate }) => {
    const [days, hours, minutes, seconds] = Countdown(targetDate);

    if (days + hours + minutes + seconds <= 0) {
        return <ExpiredNotice />;
    } else {
        return (
            <ShowCounter
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
            />
        );
    }
};

export default CountdownTimer;
